import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { pagesSection } from "@/components/sidebar/dashboardItems";

// The step order is the sidebar order, so "next"/"previous" always match it.
const order = pagesSection.map((p) => p.href);

interface StepNavProps {
  /**
   * Persist the current page. Return false to cancel navigation (e.g. on a
   * validation failure). If omitted, the primary button just advances.
   */
  onSave?: () => Promise<any> | any;
}

const StepNav: React.FC<StepNavProps> = ({ onSave }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const idx = order.indexOf(pathname);
  if (idx < 0) return null;

  const prev = idx > 0 ? order[idx - 1] : undefined;
  const next = idx < order.length - 1 ? order[idx + 1] : undefined;

  const handlePrimary = async () => {
    if (onSave) {
      const result = await onSave();
      if (result === false) return; // save was blocked (e.g. invalid) — stay put
    }
    if (next) navigate(next);
  };

  const primaryLabel = onSave ? (next ? "Save & Next" : "Save") : "Next";

  return (
    <Box mt={4} display="flex" justifyContent="space-between">
      {prev ? (
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          size="large"
          onClick={() => navigate(prev)}
        >
          Back
        </Button>
      ) : (
        <span />
      )}
      {(onSave || next) && (
        <Button
          type="button"
          variant="contained"
          color="primary"
          size="large"
          onClick={handlePrimary}
        >
          {primaryLabel}
        </Button>
      )}
    </Box>
  );
};

export default StepNav;
